import { makeInlineText } from './internal/makeInlineText';

/**
 * @deprecated используйте Paragraph1 или Body1
 */
export const InlineText1 = makeInlineText({
  fontSize: '16px',
  lineHeight: '22px'
});

/**
 * @deprecated используйте Paragraph2 или Body2
 */
export const InlineText2 = makeInlineText({
  fontSize: '14px',
  lineHeight: '20px'
});

/**
 * @deprecated используйте Paragraph3 или Body3
 */
export const InlineText3 = makeInlineText({
  fontSize: '12px',
  lineHeight: '18px'
});

/**
 * @deprecated используйте Overline
 */
export const InlineText4 = makeInlineText({
  fontSize: '10px',
  lineHeight: '16px'
});